export default __webpack_public_path__ + "static/media/wR.a5a16b36.svg";